import type { FormRule } from 'antd'
import { MAX_WHOLE_KRW_AMOUNT, MAX_WHOLE_QUANTITY } from '@repo/shared'

/**
 * 금액·수량 칸의 폼 검사 (개발항목 307 S2) — 입력 칸이 막지 못한 값(붙여넣기·초기값)도 저장 전에 거른다.
 * 서버 검사(`request-input.ts`)와 같은 상한을 쓴다.
 */

/** 원 단위 정수이고 {@link MAX_WHOLE_KRW_AMOUNT} 이하인지. */
export function wholeKrwAmountRule(message: string): FormRule {
  return { type: 'integer', max: MAX_WHOLE_KRW_AMOUNT, message }
}

/** 정수이고 {@link MAX_WHOLE_QUANTITY} 이하인지. */
export function wholeQuantityRule(message: string): FormRule {
  return { type: 'integer', max: MAX_WHOLE_QUANTITY, message }
}
